export default {
    any: $localize `Any city`,
    except: $localize `Any except`,
    selected: $localize `Only`
}